import { Component, OnInit } from "@angular/core";
import { Helicopter } from "../shared/models/helicopter.model";
import { HelicoptersService } from "../helicopters/helicopters.service";
import { LocalStorageService, UserLocalStorageObject } from "../shared/local-storage.service";

@Component({
    selector: "app-daily-checks",
    templateUrl: "./daily-checks.component.html",
    styleUrl: "./daily-checks.component.scss",
    standalone: false,
})
export class DailyChecksComponent implements OnInit {
    public helicoptersArray: Helicopter[] = [];
    public chosenAircraft: Helicopter;
    private _userSession: UserLocalStorageObject;

    public aircraftOptions: { name: string; value: number }[];
    public selectedAircraftOption: number;

    constructor(
        private _helicoptersService: HelicoptersService,
        private _localStorageService: LocalStorageService,
    ) {
        this._userSession = this._localStorageService.getUserLocalStorageObject();
    }

    ngOnInit(): void {
        this._helicoptersService.getHelicopters(this._userSession.organizationId).subscribe((helicopters) => {
            this.helicoptersArray = helicopters;
            this.aircraftOptions = this.helicoptersArray.map((h) => {
                return { name: h.registrationMark, value: h.id };
            });
            if (this.helicoptersArray.length > 0) {
                this.selectedAircraftOption = this.helicoptersArray[0].id;
                this.chosenAircraft = this.helicoptersArray[0];
            }
        });
    }

    chooseAircraft(helicopterId: number) {
        this.chosenAircraft = this.helicoptersArray.find((h) => h.id === helicopterId);
    }
}
